module.exports = __webpack_public_path__ + "img/icn-send-active.4ebc1adb.svg";